import { j as t } from "./jsx-runtime-3tyXYecC.mjs";
import { B as l, a as y, S as m, C as b, F as j, H as v, L as w, U as H } from "./upper-content-BgC1jI-u.mjs";
import { r as x } from "./index-lgh2EImO.mjs";
import { f as e } from "./index-LyFokDcn.mjs";
import { m as f } from "./mobile-BpUO1OTk.mjs";
import { m as p } from "./tss-DN0acMKN.mjs";
import { M as B } from "./constants-CnFYFetN.mjs";
import { C as k } from "./enums-BtUzbEmn.mjs";
import { u as g } from "./use-screen-sizes-hx44ztp3.mjs";
import { I as R } from "./icon-CvGUqXUP.mjs";
import { L } from "./layout-box-DFBM-kSI.mjs";
import { F as T } from "./flex-Cc3osQLf.mjs";
import { H as M } from "./headline-DF2GOgMa.mjs";
import { I as N } from "./icon-tile-BJ1ib0c2.mjs";
const I = p()((n, a) => {
  const { breakpoints: r, constructs: o, palette: i, spacing: c, mode: d } = n, { noPadding: u } = a;
  return {
    body: {
      backgroundColor: e.ifFeature("encore", i.gray[50], i.common.white),
      borderRadius: e.ifFeature("encore", "16px"),
      display: "flex",
      flexDirection: "column",
      height: "100%",
      overflow: e.ifFeature("encore", "hidden"),
      width: e.ifFeature("encore", "auto", "100%"),
      [r.down(f)]: e.ifFeature("encore", {
        backgroundColor: o.surface.neutral.inverted,
        padding: c(0.5)
      })
    },
    content: {
      display: "flex",
      flexDirection: "column",
      flexGrow: "1",
      overflow: "auto",
      padding: u && d !== B.Dye ? "0" : "16px",
      [r.down("md")]: {
        padding: u ? "0" : "8px"
      }
    },
    roundBottomCorners: e.ifFeature(
      "encore",
      {
        // This is done so custom footers have rounded bottom corners when the body has padding
        borderBottomLeftRadius: e.ifFeature("encore", o.radius.xSmall),
        borderBottomRightRadius: e.ifFeature("encore", o.radius.xSmall),
        flexShrink: "0",
        // Used by Safari to keep the footer from shrinking when the body has a lot of content
        minHeight: "fit-content",
        // Keeps the footer from being cut off when the body has a lot of content
        overflow: "hidden"
      },
      {}
    ),
    roundTopCorners: e.ifFeature(
      "encore",
      {
        // This is done so custom headers such as the ActionBanner can have rounded top corners when the body has padding
        borderTopLeftRadius: o.radius.xSmall,
        borderTopRightRadius: o.radius.xSmall,
        flexShrink: "0",
        // Used by Safari to keep the header from shrinking when the body has a lot of content
        minHeight: "fit-content",
        // Keeps the header from being cut off when the body has a lot of content
        overflow: "hidden"
      },
      {}
    )
  };
}), $ = (n) => {
  const { children: a, noPadding: r = !1, renderFooter: o, renderHeader: i, ...c } = n, { classes: d } = I({ noPadding: r }), u = x(i), C = x(o);
  return /* @__PURE__ */ t.jsx(l.Body, { ...c, children: /* @__PURE__ */ t.jsxs("div", { className: d.body, children: [
    /* @__PURE__ */ t.jsx("div", { className: d.roundTopCorners, children: u }),
    /* @__PURE__ */ t.jsx("div", { className: d.content, children: a }),
    /* @__PURE__ */ t.jsx("div", { className: d.roundBottomCorners, children: C })
  ] }) });
}, h = (n) => /* @__PURE__ */ t.jsx(y, { ...n, canScroll: !1 });
h.Spacing = k;
const P = p()((n) => {
  const { breakpoints: a, palette: r, constructs: o, spacing: i } = n;
  return {
    footer: {
      backgroundColor: e.ifFeature("encore", r.common.white, r.gray[100]),
      borderBottomLeftRadius: e.ifFeature("encore", "16px"),
      borderBottomRightRadius: e.ifFeature("encore", "16px"),
      borderTop: e.ifFeature("encore", `1px solid ${r.gray[200]}`, `1px solid ${r.gray[300]}`),
      flexShrink: 0,
      padding: e.ifFeature("encore", i(3, 5), "24px 32px 32px"),
      /* @startCleanup encore */
      [a.down("md")]: {
        padding: e.ifFeature("encore", void 0, "12px 24px 32px")
      },
      [a.down(500)]: {
        padding: e.ifFeature("encore", void 0, "8px 16px 20px")
      },
      /* @endCleanup encore */
      [a.down(f)]: e.ifFeature("encore", {
        backgroundColor: o.surface.neutral.xxWeak,
        padding: i(2, 2.5)
      })
    }
  };
}), z = (n) => {
  const { classes: a } = P(), { isMediumScreen: r } = g(!0);
  return /* @__PURE__ */ t.jsx("div", { className: a.footer, children: /* @__PURE__ */ t.jsx(l.Footer, { actionAlignment: r ? "end" : "start", ...n }) });
}, F = (n) => {
  const { children: a, icon: r, text: o } = n, { isMediumScreen: i } = g(!0);
  return /* @__PURE__ */ t.jsxs(T, { alignItems: "center", children: [
    r ? /* @__PURE__ */ t.jsx(L, { component: "span", marginRight: 2, children: typeof r == "string" ? /* @__PURE__ */ t.jsx(R, { brand: !0, name: r }) : r }) : null,
    o ? e.ifFeature("encore", /* @__PURE__ */ t.jsx(M, { size: i ? "small" : "large", children: o }), /* @__PURE__ */ t.jsx("h2", { children: o })) : null,
    a
  ] });
}, D = p()((n) => {
  const { breakpoints: a, constructs: r, palette: o, spacing: i } = n;
  return {
    header: {
      alignItems: "center",
      backgroundColor: e.ifFeature("encore", o.common.white, o.gray[100]),
      borderBottom: e.ifFeature("encore", `1px solid ${o.gray[200]}`, `1px solid ${o.gray[300]}`),
      borderTopLeftRadius: e.ifFeature("encore", "16px"),
      borderTopRightRadius: e.ifFeature("encore", "16px"),
      display: "flex",
      flexShrink: "0",
      padding: e.ifFeature("encore", i(0.5, 2.5), "0 32px"),
      [a.down(f)]: e.ifFeature("encore", {
        backgroundColor: r.surface.neutral.xxWeak,
        padding: 0
      }),
      // startCleanup encore
      minHeight: e.ifFeature("encore", void 0, "80px"),
      [a.down("md")]: {
        padding: e.ifFeature("encore", void 0, i(0, 3))
      }
      // endCleanup encore
    }
  };
}), S = (n) => {
  const { children: a, icon: r, title: o, ...i } = n, { classes: c } = D(), d = o ? /* @__PURE__ */ t.jsx(F, { icon: r, text: o }) : null;
  return /* @__PURE__ */ t.jsx("div", { className: c.header, children: /* @__PURE__ */ t.jsx(l.Header, { inverted: !0, ...i, children: a || d }) });
};
S.Title = F;
const U = p()(() => ({
  root: {
    paddingLeft: e.ifFeature("encore", void 0, "16px"),
    paddingRight: e.ifFeature("encore", void 0, "16px")
  }
})), W = (n) => {
  const { icon: a, ...r } = n, { classes: o } = U();
  return /* @__PURE__ */ t.jsx("div", { className: o.root, children: e.ifFeature(
    "encore",
    /* @__PURE__ */ t.jsx(
      m,
      {
        icon: a && typeof a == "string" ? /* @__PURE__ */ t.jsx(N, { icon: a, size: 56, variant: "primary" }) : void 0,
        ...r
      }
    ),
    /* @__PURE__ */ t.jsx(m, { ...n })
  ) });
}, s = (n) => /* @__PURE__ */ t.jsx(
  l,
  {
    ...n,
    contentStyles: {
      height: "100%",
      width: "100%"
    },
    "data-fabric-component": [n["data-fabric-component"], "FullScreenModal"].filter(Boolean).join(" ")
  }
);
s.Body = $;
s.CloseButton = l.CloseButton;
s.ConfirmationContent = b;
s.Constraint = h;
s.FocalContent = j;
s.Footer = z;
s.Header = S;
s.HeroHeadline = v;
s.LowerContent = w;
s.StandardHeadline = W;
s.UpperContent = H;
export {
  s as F
};
//# sourceMappingURL=full-screen-modal-DAhgcMpO.mjs.map
